<template>
    <table class="table">
        <tr v-for="sport_event in sport_events">
            <td>{{ sport_event.scheduled }}<br>({{ sport_event.status }})</td>
            
            <td v-for="competitor in sport_event.competitors">
                {{ competitor.name }}<br>({{ competitor.qualifier}})
            </td>

            <td v-for="market in sport_event.markets">
                <b>{{ market.name }}</b>

                <table>
                    <tr v-for="book in market.books">
                        <td>
                            {{ book.name }}	
                            <br>
                            {{ book.id }}
                        </td>
                        
                        <td v-for="outcome in book.outcomes">
                            {{ outcome.type }} - {{ outcome.odds }}

                            <div v-if="market.name == '3way'">
                                opening odds: {{ outcome.opening_odds }}
                                <br>
                                trend: {{ outcome.odds_trend }}
                            </div>
                            
                            <div v-if="market.name == 'total'">
                                opening odds: {{ outcome.opening_odds }}
                                <br>
                                trend: {{ outcome.odds_trend }}
                                <br>
                                total: {{ outcome.total }}
                                <br>
                                opening total: {{ outcome.opening_total }}
                            </div>

                            <div v-if="market.name == 'handicap'">
                                opening odds: {{ outcome.opening_odds }}
                                <br>
                                trend: {{ outcome.odds_trend }}
                                <br>
                                handicap: {{ outcome.handicap }}
                            </div>

                            <div v-if="market.name == 'asian_handicap'">
                                opening odds: {{ outcome.opening_odds }}
                                <br>
                                trend: {{ outcome.odds_trend }}
                                <br>
                                handicap: {{ outcome.handicap }}
                            </div>

                            <div v-if="market.name == '2way'">
                                opening odds: {{ outcome.opening_odds }}
                                <br>
                                trend: {{ outcome.odds_trend }}
                            </div>

                            <div v-if="market.name == 'spread' || market.name == 'run_line' || market.name == 'puck_line'">
                                opening odds: {{ outcome.opening_odds }}
                                <br>
                                trend: {{ outcome.odds_trend }}
                                <br>
                                spread: {{ outcome.spread }}
                                <br>
                                opening spread: {{ outcome.opening_spread }}
                            </div>
                        </td>
                    </tr>	
                </table>					
            </td>
        </tr>
    </table>
</template>

<script>
export default {
    name: 'OddsTable',
    props: {
        sport_events: ''
    }
}
</script>

